<button
  *ngIf="message"
  class="container"
  mat-button
  [routerLink]="routerLink"
  [ngClass]="class"
  [matTooltipDisabled]="!showTooltips"
  [matTooltip]="message"
>
  <div fxLayout="row" fxLayoutAlign="start center">
    <app-icon [name]="icon" size="20"></app-icon>

    <div class="content">
      {{ message }}
    </div>
  </div>
</button>
